export default __webpack_public_path__ + "static/media/download_1.8d95a7f6.svg";